import * as React from 'react';
import { SVGProps } from 'react';

const IconDocDeleteSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l6.828 6.828A2 2 0 0 1 24 10.828V24a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm10 0 8 8h-6a2 2 0 0 1-2-2V4Zm1.232 11.11L17 16.88l1.768-1.768 2.121 2.121L19.121 19l1.768 1.768-2.121 2.121L17 21.121l-1.768 1.768-2.121-2.121L14.879 19l-1.768-1.768 2.121-2.121Z"
    />
  </svg>
);
export default IconDocDeleteSizeL;
